import * as React from 'react';
import {Text, View} from 'react-native';
import {images} from '../../../../../assets/icons';
import {Button} from '../../../../../shared/components/button';
import Screen from '../../../../../shared/components/screen';
import {CustomScrollView} from '../../../../../shared/components/scrollView';
import {useStyles} from '../../../../../shared/hooks/styles';
import {useBlockCardDialog} from '../../../../../shared/hooks/useBlockCardDialog';
import {Content} from '../../../../../shared/models/content';
import {useTheme} from '../../../../../shared/theme';
import {CardInfoCardBlocked} from '../../../../../shared/components/cardInfo/components/cardBlocked';
import {UscType} from '../../../../../shared/models/profile/uscType';
import {useSelector} from 'react-redux';
import {holderProfileSelector} from '../../../../../redux/selectors/profile';

interface Props {
  cardIsBlocked: boolean;
  canReissueCard: boolean;
  content: Content;
}

export default ({cardIsBlocked, canReissueCard, content}: Props) => {
  const showBlockCardDialog = useBlockCardDialog();
  const theme = useTheme();
  const {uscType = 0} = useSelector(holderProfileSelector()) || {};
  const isNonFinancial = uscType === UscType.NonFinancial;

  const styles = useStyles(() => {
    return {
      scrollContainer: {
        flexGrow: 1,
        flexDirection: 'column',
        alignItems: 'stretch',
        paddingBottom: 80,
        paddingHorizontal: 16,
      },
      message: {
        ...theme.fonts.body,
        color: theme.color.textColor,
        marginVertical: 40,
        textAlign: 'center',
      },
      button: {
        width: '100%',
      },
      buttonText: {
        color: theme.color.primaryColor,
      },
      cardBlockedContainer: {
        marginTop: 40,
        marginBottom: 30,
      },
      buttonWrap: {
        paddingHorizontal: 20,
      },
    };
  });

  return (
    <Screen>
      <CustomScrollView contentContainerStyle={styles.scrollContainer} contentInsetAdjustmentBehavior='automatic'>
        {canReissueCard ? (
          <View style={styles.cardBlockedContainer}>
            <CardInfoCardBlocked />
          </View>
        ) : (
          <Text style={styles.message} testID='safety-block-message'>
            {cardIsBlocked ? content.cardBlocking.unblockMessage : content.cardBlocking.blockMessage}
          </Text>
        )}
        {isNonFinancial && (
          <View style={styles.buttonWrap}>
            <Button
              id='profile-safety-block-card'
              disabled={cardIsBlocked}
              type='secondary'
              text='Заблокировать карту'
              textStyle={styles.buttonText}
              icon={images.Lock}
              iconPosition='left'
              block
              style={styles.button}
              iconProps={{color: theme.color.primaryColor}}
              onPress={showBlockCardDialog}
            />
          </View>
        )}
      </CustomScrollView>
    </Screen>
  );
};
